import { GridValidRowModel } from "@mui/x-data-grid-pro";
//MUZUN;454081;07042025
const AdverseReactions : GridValidRowModel[] = [
    {
      id: 1,
      registeredUser: "Sinerji Bilişim",
      adversEffect: "",
      startTime: "07.03.2025",
      endTime: "",
      edit: "",
      date: "07.03.2025",
    },
  ];


  export default AdverseReactions;